import useAppTranslation from "@hooks/language/useAppTranslation";
import useUserStore from "@store/user.store";
import CopyText from "./CopyText";
import ContainerCard, {
  type IContainerCardProps,
} from "./container/ContainerCard";
import ContainerText from "./container/ContainerText";

const envVars = import.meta.env;

export interface IAffiliateCardProps {
  containerProps?: IContainerCardProps;
  affiliateCode?: string;
}

const AffiliateLinkCard: React.FC<IAffiliateCardProps> = ({
  containerProps,
  affiliateCode,
}) => {
  const { affiliationInformation } = useUserStore();
  const { t } = useAppTranslation("pages.clientDashboard.components");

  return (
    <ContainerCard title={t("affiliateLinkCard.title")} {...containerProps}>
      <CopyText
        isGradient
        value={`${envVars.VITE_FRONT_URL}/?ref=${affiliationInformation?.affiliateCode ?? affiliateCode ?? ""}`}
        openInNewTab
        classNames={{ root: "w-full", label: "text-wrap text-primary-white" }}
      >
        {`${envVars.VITE_FRONT_URL}/?ref=${affiliationInformation?.affiliateCode ?? affiliateCode ?? ""}`}
      </CopyText>
      <ContainerText className="text-center">
        {t("affiliateLinkCard.text")}
      </ContainerText>
    </ContainerCard>
  );
};

export default AffiliateLinkCard;
